/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Linked_AccountsInputs */



/**
* | output |
* | --- |
* | "Linked Accounts" |
*
* @param {Profile_Linked_AccountsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_linked_accounts = /** @type {((inputs?: Profile_Linked_AccountsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Linked_AccountsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comptes liés")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cuentas vinculadas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Contas Vinculadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Account Collegati")
	return /** @type {LocalizedString} */ ("Linked Accounts")
});